<template>
  <div class="column has-text-left">
    <button class="button is-info js-modal-trigger" v-on:click="openModal" data-target="close-ticket-modal">Отменить обращение</button>
  </div>
  <div id="close-ticket-modal" class="modal">
    <div class="modal-background" v-on:click="closeModal"></div>
    <div class="modal-content">
      <div class="box">
        <textarea v-model="reason" class="textarea is-dark" placeholder="Введите обоснование отмены обращения"></textarea>
        <button class="button is-dark is-fullwidth cancel-button" :class="deactivate ? 'is-loading' : ''" v-on:click="cancelTicket" :disabled="!reason || deactivate">ОТМЕНИТЬ ОБРАЩЕНИЕ</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CancelTicket",
  data() {
    return {
      reason: null,
      deactivate: false
    }
  },
  props: ['ticket'],
  mounted() {

  },
  methods: {
    cancelTicket: async function () {
      this.deactivate = true
      let url = `${this.$config.SSL}://${this.$config.ONEADDRESS}/${this.$config.DB}/${this.$config.API_VERSION}/CancelTicket`
      let data = {
        doc_guid: this.ticket['Ссылка'],
        reason: this.reason
      }
      let properies = {
        method: 'POST',
        body: JSON.stringify(data),
        withCredentials: true,
        headers: {
          "Authorization": "Bearer " + this.$store.getters.TOKEN
        }
      }
      await fetch(url, properies)
          .then(response => response.text())
          .then(result => {
            if (JSON.parse(result).status && JSON.parse(result).status === 'ERROR') {
              alert('Ошибка! попробуйте через несколько минут!')
              this.deactivate = true
            } else {
              window.location.replace('/')
            }
          })
    },
    openModal: function () {
      let modal = document.getElementById('close-ticket-modal')
      console.log(modal.classList.toString().includes('is-active'))
      if (!modal.classList.toString().includes('is-active')) {
        modal.classList.add('is-active')
      }
    },
    closeModal: function () {
      let modal = document.getElementById('close-ticket-modal')
      if (modal.classList.toString().includes('is-active')) {
        modal.classList.remove('is-active')
      }
    }
  }
}
</script>

<style scoped>
.textarea {
  border-radius: 5px 5px 0 0 !important;
}
.cancel-button {
  border-radius: 0 0 5px 5px !important;
}
.is-info {
  background: rgb(131, 113, 119) !important;
  transition: 0.3s;
}
</style>